import { MetricsTransactionVolumeOverTime } from 'dashboard/models/metrics-transaction';
import Action from 'lib/interfaces/Action';
import { Iso8601DateString } from 'lib/types';

export interface MetricsFilterParams {
  createdAtStart?: Iso8601DateString;
  createdAtEnd?: Iso8601DateString;
  transactionTypeIds: string[];
}

interface MetricsFiltersPayload {
  filters: Partial<MetricsFilterParams>;
}

interface MetricsTransactionVolumeOverTimePayload {
  transactionVolumeOverTime: MetricsTransactionVolumeOverTime;
  queriedAt?: Iso8601DateString;
}

export type MetricsActions =
  | Action<MetricsTransactionActionType.SetMetricsFilters, MetricsFiltersPayload>
  | Action<MetricsTransactionActionType.ResetMetricsDateFilter>
  | Action<
      MetricsTransactionActionType.SetMetricsTransactionVolumeOverTime,
      MetricsTransactionVolumeOverTimePayload
    >
  | Action<MetricsTransactionActionType.ClearMetrics>;

export enum MetricsTransactionActionType {
  SetMetricsTransactionVolumeOverTime = 'metrics/SET_METRICS_TRANSACTION_VOLUME_OVER_TIME',
  SetMetricsFilters = 'metrics/SET_METRICS_FILTERS',
  ResetMetricsDateFilter = 'metrics/RESET_METRICS_DATE_FILTERS',
  ClearMetrics = 'metrics/CLEAR_METRICS',
}

export function setMetricsVolumeOverTime(
  transactionVolumeOverTime: MetricsTransactionVolumeOverTime,
  queriedAt: Iso8601DateString,
): Action<
  MetricsTransactionActionType.SetMetricsTransactionVolumeOverTime,
  MetricsTransactionVolumeOverTimePayload
> {
  return {
    payload: {
      transactionVolumeOverTime,
      queriedAt,
    },
    type: MetricsTransactionActionType.SetMetricsTransactionVolumeOverTime,
  };
}

export function setMetricsFilters(
  filters: Partial<MetricsFilterParams>,
): Action<MetricsTransactionActionType.SetMetricsFilters, MetricsFiltersPayload> {
  return {
    payload: {
      filters,
    },
    type: MetricsTransactionActionType.SetMetricsFilters,
  };
}

export function resetMetricsDateFilter(): Action<MetricsTransactionActionType.ResetMetricsDateFilter> {
  return {
    type: MetricsTransactionActionType.ResetMetricsDateFilter,
  };
}

export function clearMetrics(): Action<MetricsTransactionActionType.ClearMetrics> {
  return {
    type: MetricsTransactionActionType.ClearMetrics,
  };
}
